import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { sockets } from 'utils';

import * as Actions from 'actions';

class AvatarSelector extends React.Component {
	constructor(props) {
		super(props);

		this.renderAvatars = this.renderAvatars.bind(this);
	}

	componentWillMount() {
    this.socket = sockets();

  	this.socket.emit('get-avatars');
		this.socket.on('avatars-received', (avatars, response) => {
			this.props.initUserAvatars(avatars);
		});
  }

	renderAvatars() {
		let user = this.props.users.tmp_user;

		var class_name;
		return this.props.users.avatars.map((avatar_path, index) => {

			return (
				<div
					key={index}
					className='col-md-3 col-xs-12 mb-sm individual-avatar-container'
					name='avatar'
					id={avatar_path}
					onClick={this.props.handleChange}
					>
					<img
						src={avatar_path}
						name='avatar'
						id={avatar_path}
						className={
							(user && user.avatar && avatar_path === user.avatar) ?
							'animated pulse individual-avatar' :
							'individual-avatar'
						}
						/>
				</div>
			)
		})
	}

	render() {
		return (
			<div className='avatar-selector-container panel'>
				<div className='col-md-10 col-md-offset-1'>
					<div className='panel-body'>
						<div className='avatars-wrapper'>
							{this.renderAvatars()}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect(({users}) => ({users}), Actions)(AvatarSelector)



// WEBPACK FOOTER //
// ./src/browser/components/ui/avatarSelector.js